import React, { useState, useEffect, useContext, useRef } from 'react';
import { getConfiguration} from '../utils';
import { systemCode, xs_sessionToken, xs_languageCode } from '../..';
import { PvrContext } from '../pvr/PvrConf';
import { ShopContext } from '../shop/ShopConf';
import $ from 'jquery';

export const UserContext = React.createContext(null);


function UserConf(props) {
	//const appContext = useContext(AppContext);
	const frontendVersion = props.frontendVersion; // for new mobile, use frontendVersion="mobile_2"
	const conf = getConfiguration();
	const ctxs = useRef({}).current;
    ctxs.pvrContext = useContext(PvrContext);
	ctxs.shopContext = useContext(ShopContext);
	
    const [userContext, setUserContext] = useState({
    	user : {logged : false, bonusEnabled : true},
    	sessionToken : ctxs.pvrContext.pvrSectionEnabled? "": xs_sessionToken,
    	initialized : false,
    	contextId : new Date().getTime(),
    	
    	updateFullContext : function(updt) {
			// updating temporary
			for(let ko in updt){
				const val = updt[ko];
				ctxs.userContext[ko] = val;
			}
			//update effectly
			setUserContext(prev => {
                return {...prev, ...updt};
            });
        },
		reloadSessionTokenFromAppConfig : function() {
			ctxs.userContext.updateFullContext({sessionToken : xs_sessionToken, initialized : false});
			ctxs.userContext.loadUser();
		},
    	setPvrUser : function (pvrUser){
    		if(ctxs.pvrContext.pvrSectionEnabled){
    	    	ctxs.userContext.updateFullContext({
    	    		initialized : true,
    	    		user : pvrUser,
    	    		sessionToken : pvrUser.sessionToken
    	    	});
    		} 
    	},
		setShopUser : function (shopUser){
    		if(ctxs.shopContext.enabled){
    	    	ctxs.userContext.updateFullContext({
    	    		initialized : true,
    	    		user : shopUser,
    	    		sessionToken : shopUser.sessionToken
    	    	});
    		} 
    	},
    	
    	loadUser : function(){
    		if(ctxs.userContext.sessionToken != null && ctxs.userContext.sessionToken.length > 0 && !ctxs.userContext.initialized){
    			console.log('session token is ' + ctxs.userContext.sessionToken);
    			const url = getConfiguration().api.getUser;
    			const params = {
    					systemCode : systemCode,
    					lingua: xs_languageCode,
    					hash: '',
    					token : ctxs.userContext.sessionToken,
    					frontendVersion
    			}
    	    	ctxs.userContext.updateFullContext({initialized : true});
    	    	
    			ctxs.userContext.getUserData(url, params, (response) => {
    				if(response != null){
    					if(response.frontendJsonConfiguration){
    						response.frontendJsonConfiguration = JSON.parse(response.frontendJsonConfiguration);
							window.settingsFromDB = response.frontendJsonConfiguration;
							window.dispatchEvent(new CustomEvent('xs_updateUserSettings'));
    					} 
    					else {
    						if(window.getSettingsToSaveOnDB){
	    						const settings = window.getSettingsToSaveOnDB();
								if (settings != null) {
									ctxs.userContext.saveSportFrontendConfiguration(settings);
								}
    						}

						}
						if(response.generalFrontendJsonConfiguration){
							response.generalFrontendJsonConfiguration = JSON.parse(response.generalFrontendJsonConfiguration);
						}
						if(response.funbonuses){
							response.funbonuses = JSON.parse(response.funbonuses);
						}
						if(response.freebets){
							response.freebets = JSON.parse(response.freebets);
						}
						if(response.operatorWhitelabel){
							// it is a retail distro in whitelabel
							if(response.logged){
								window.setLoggedParametersOnLS(response);							
							}
							else{
								window.removeLoggedParametersOnLS();
							}
						}
    					ctxs.userContext.updateFullContext({user : response});
						if(props.setUserLogged){
							props.setUserLogged(userContext.user.logged);
						}
						if(ctxs.userContext.user.logged){
							// saving in the local storage its account ids
							const accountIds = [ctxs.userContext.user.accountId, ctxs.userContext.user.accountIdB2b].join(';');
							localStorage.setItem('lastLoggedUserAccountIds', accountIds);
						}
    	    	    	ctxs.userContext.updateFullContext({contextId : new Date().getTime()});
    				}
    			},
    			(error) =>{
//    				ctxs.userContext.initialized = true;
    			});
    		}   		
    	},
    	
    	saveSportFrontendConfiguration : function (frontendConf){
		    const params = {
		            systemCode,
		            lingua: xs_languageCode,
		            hash: '',
		            token : ctxs.userContext.sessionToken,
		            frontendVersion
		            
		    };
		    const url = getConfiguration().api.setSportFrontendUserSettings;
		    if(url){
		        $.ajax({
		    		type: "POST",
		    		url : url + "?" +  $.param(params),
		    		data: window.encodeURI(JSON.stringify(frontendConf)),
		            dataType: 'json',
		            contentType: "application/json; charset=UTF-8;",
		            headers:{
		            	'Cache-Control': 'no-transform'
		            },
		    		success : (data) => {
		    			console.log(data);
		    		}
		        });
		    }
    	},

 		// stabilisce il comportamento del sistema delle notifiche: abilitazione delle notifiche di vincita
 		setAutoNotificationWinningTicket : function (enabled){
 			if(conf.pnc?.enabled && ctxs.userContext.user?.logged){
 				ctxs.userContext.saveGeneralFrontendConfiguration({ autoNotificationWinningTicket : enabled}); 			
 			}
 		},
 		// stabilisce il comportamento del sistema delle notifiche: abilitazione delle notifiche di cambio risultato eventi
 		setAutoNotificationEventsScore : function (enabled){
 			if(conf.pnc?.enabled && ctxs.userContext.user?.logged){
 				ctxs.userContext.saveGeneralFrontendConfiguration({ autoNotificationEventsScore : enabled});
 			}
 		},
 		 		
 		
 		isAutoNotificationWinningTicketEnabled : function(){
 			let enabled = false;
 			if(ctxs.userContext.user?.logged && conf.pnc?.enabled){
 				enabled = conf.pnc?.defaultWinningNotification;
 				// se l'utente ha specificato la sua preferenza, la considero
 				if(ctxs.userContext.user.generalFrontendJsonConfiguration?.autoNotificationWinningTicket !== undefined){
	 				enabled = ctxs.userContext.user.generalFrontendJsonConfiguration.autoNotificationWinningTicket;
 				}
 			}
 			return enabled;
 		},
 		
 		isAutoNotificationEventsScoreEnabled : function(){
 			let enabled = false;
 			if(ctxs.userContext.user?.logged && conf.pnc?.enabled){
 				enabled = conf.pnc?.defaultEventNotification;
 				// se l'utente ha specificato la sua preferenza, la considero
 				if(ctxs.userContext.user.generalFrontendJsonConfiguration?.autoNotificationEventsScore !== undefined){
	 				enabled = ctxs.userContext.user.generalFrontendJsonConfiguration.autoNotificationEventsScore;
 				}
 			}
 			return enabled;
 		},
 		
     	saveGeneralFrontendConfiguration : function (propertiesToSave){
		    const params = {
		            systemCode,
		            lingua: xs_languageCode,
		            hash: '',
		            token : ctxs.userContext.sessionToken,
		            frontendVersion : 'general'
		            
		    };
		    const user = ctxs.userContext.user;
		    // i take the setted configuration, I add the properties to save, and I save the whole object
		    const frontendConf = user.generalFrontendJsonConfiguration? {...user.generalFrontendJsonConfiguration} : {};
		    for(let kp in propertiesToSave){
		    	frontendConf[kp] = propertiesToSave[kp];
		    }
		    user.generalFrontendJsonConfiguration = frontendConf;
		    ctxs.userContext.updateFullContext({user : user});
		    const url = getConfiguration().api.setSportFrontendUserSettings;
		    if(url){
		        $.ajax({
		    		type: "POST",
		    		url : url + "?" +  $.param(params),
		    		data: window.encodeURI(JSON.stringify(frontendConf)),
		            dataType: 'json',
		            contentType: "application/json; charset=UTF-8;",
		            headers:{
		            	'Cache-Control': 'no-transform'
		            },
		    		success : (data) => {
		    			console.log(data);
		    		}
		        });
		    }
    	},   	
    	getUserData : async (url, params, callback, errorCallback) => {
			$.ajax({
	    		url,
	    		type: "POST",
	    		data: params,
	    		success : (data) => {
	    			callback(JSON.parse(data));
	    		},
	    		error : () => {
	    			errorCallback && errorCallback();
	    		}	
		    });
 	    },
 	    isInitialized : function(){
 	    	return ctxs.userContext.initialized;
 	    },
 	    getUser : function (){
 	    	return ctxs.userContext.user;
 	    },
 	    getLastTickets : function(){
 	    	if(ctxs.userContext.user.logged){
 	    		return ctxs.userContext.user.lastTickets;
 	    	}
 	    	return null;
 	    },
 	    
 	    
 	    reloadUser : function(){
			ctxs.userContext.updateFullContext({initialized : false});
 	    	ctxs.userContext.loadUser();
 	    }
    	
    });
    ctxs.userContext = userContext;
    useEffect(() => {
		if(ctxs.shopContext.enabled){
			const shopUser = ctxs.shopContext.getShopUser();
			if(shopUser){
				userContext.setShopUser(shopUser);				
			}
		}
    	else if(ctxs.pvrContext.pvrSectionEnabled){
    		userContext.setPvrUser(ctxs.pvrContext.userLoggedFromPvr);
    	}
		else{
			if(userContext.isInitialized() == false){
				userContext.loadUser();
			}
		}
		window.ucReloadUser = function () {
			ctxs.userContext.reloadSessionTokenFromAppConfig();
		};
   }, [ctxs.pvrContext.userLoggedFromPvr, ctxs.shopContext.getShopUser()], []);
   

    return (
    	<UserContext.Provider value={userContext}>
    	    {props.children}
    	</UserContext.Provider>
    );
}

export default UserConf;